module.exports = __webpack_public_path__ + "images/mstile-150x150-ba018bc6dadf23c0b9e6477a3d114e86.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicons/mstile-150x150.png
// module id = ./src/images/favicons/mstile-150x150.png
// module chunks = 1